export default class ActivedFilter{
  constructor(element){
    $('.portifolio-filter .action-filter').removeClass('active');
    $(element).addClass('active');
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/actived_filter.js
// module id = 18
// module chunks = 0